import { render } from "./Checkbox.vue?vue&type=template&id=5a9ace73&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=5a9ace73&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a9ace73"

export default script